import { IonContent, IonPage } from '@ionic/react'
import React, { lazy } from 'react'
import useAuthStore from 'store/userStore'
import { UserRoles } from 'types/enum/enum'

const DashboardPage = lazy(() =>
  import('pages/dashboard').then((module) => ({
    default: module.DashboardPage
  }))
)
const DirectorDashboardPage = lazy(() =>
  import('pages/director-dashboard').then((module) => ({
    default: module.DirectorDashboardPage
  }))
)

export const DashboardView: React.FC = () => {
  const { user } = useAuthStore()
  const userProgramDirector = user?.roles?.includes(UserRoles.DIRECTOR)
  return (
    <>
      {userProgramDirector ? (
        <IonPage>
          <IonContent style={{ '--background': 'none' }}>
            <DirectorDashboardPage />{' '}
          </IonContent>
        </IonPage>
      ) : (
        <IonPage>
          <IonContent style={{ '--background': 'none' }}>
            <DashboardPage />
          </IonContent>
        </IonPage>
      )}
    </>
  )
}
